var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.FormButtonDisabler,
    [
      _c(
        _setup.Field,
        {
          staticClass: "pb-2",
          attrs: {
            label: "Price Model",
            "error-text": _setup.showValidations ? _setup.validations.name : "",
          },
        },
        [
          _c(_setup.TextField, {
            model: {
              value: _setup.name,
              callback: function ($$v) {
                _setup.name = $$v
              },
              expression: "name",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c("div", { staticClass: "flex-grow" }),
          _vm._v(" "),
          _c(
            _setup.Btn,
            {
              on: {
                click: function ($event) {
                  return _vm.closeProp()
                },
              },
            },
            [_vm._v("Add New Price Model")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }